import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories, getCategoryBySlug } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryBySlug(slug || '');
  const [activeCategory, setActiveCategory] = useState(slug || '');

  useEffect(() => {
    setActiveCategory(slug || '');
    window.scrollTo(0, 0);
  }, [slug]);

  const articles = getArticlesByCategory(activeCategory);
  const activeCategoryData = getCategoryBySlug(activeCategory);

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb />

            <div className="mb-10">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                {activeCategoryData?.name || '分类页面'}
              </h1>
              <p className="text-sm text-foreground-500">
                {activeCategoryData?.description || '浏览所有文章'}
              </p>
            </div>

            <div className="flex flex-wrap gap-2 mb-10 border-b border-background-200/70 pb-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap ${
                    activeCategory === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {articles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-14">
                {articles.map((article) => (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
                  >
                    <div className="aspect-[16/10] overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-2 mb-2 flex-wrap">
                        {article.isHot && (
                          <span className="text-xs px-2 py-1 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                            热门
                          </span>
                        )}
                        {article.isNew && (
                          <span className="text-xs px-2 py-1 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                            最新
                          </span>
                        )}
                        <span className="text-xs text-foreground-400">{article.date}</span>
                        <span className="text-xs text-foreground-400">{article.readTime} 分钟阅读</span>
                      </div>
                      <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                        {article.title}
                      </h3>
                      <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                        {article.excerpt}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-100">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}